import React from 'react';
import { CheckIcon } from 'lucide-react';
export function BenefitsGrid() {
  const benefits = ['Crea tu cuenta de TikTok Shop en 30 minutos', 'Los 100 productos que mejor venden en México', '50 scripts de video probados ($500k+ en ventas)', 'Consigue 1,000 seguidores en 7 días', 'Fórmula exacta para videos que venden', 'Maneja pagos y entregas sin complicaciones', 'Escala de $500 a $2,000+ MXN por semana', 'Evita los 7 errores del 90% de principiantes', 'Plantillas de Canva listas para usar', 'Grupo privado de WhatsApp con 2,000+ mujeres', 'Actualizaciones de por vida gratis', 'Soporte directo si te atoras'];
  return <section className="section-spacing bg-gradient-warm" data-id="element-150">
      <div className="container-premium" data-id="element-151">
        <div className="text-center mb-10" data-id="element-152">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black text-deep-cocoa mb-3" data-id="element-153">
            Todo lo que aprenderás
          </h2>
          <p className="text-base text-deep-cocoa/70" data-id="element-154">
            Sistema completo para empezar y tener éxito
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 max-w-5xl mx-auto mb-8" data-id="element-155">
          {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-2.5 bg-white rounded-lg p-3.5 shadow-soft animate-fade-in-up" style={{
          animationDelay: `${index * 50}ms`
        }} data-id="element-156">
              <CheckIcon className="w-4 h-4 text-accent-success flex-shrink-0 mt-0.5" data-id="element-157" />
              <span className="text-deep-cocoa/90 text-sm leading-relaxed" data-id="element-158">
                {benefit}
              </span>
            </div>)}
        </div>

        {/* Value proposition */}
        <div className="max-w-2xl mx-auto bg-white rounded-xl p-6 shadow-medium text-center" data-id="element-159">
          <p className="text-xl font-black text-deep-cocoa mb-2" data-id="element-160">
            Todo esto por $190 MXN
          </p>
          <p className="text-base text-deep-cocoa/70 mb-5" data-id="element-161">
            Menos que una comida familiar. Recuperas tu inversión en la primera
            semana.
          </p>
          <a href="https://buy.stripe.com/dRm28rgfodEa83g1X618c00" className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-gradient-to-r from-cta-primary to-cta-secondary text-white font-bold rounded-xl shadow-glow-orange hover:shadow-xl hover:scale-105 transition-all duration-300" data-id="element-162">
            Sí, Quiero Empezar Ahora
          </a>
        </div>
      </div>
    </section>;
}